<template>
  <div v-if="isPermission">
    <CCol md="12" lg="12">
      <CCard class="shadow-sm">
        <CCardBody>
          <CRow>
            <CCol md="10" sm="9" col="9">
              <div class="row">
                <CIcon
                  size="2xl"
                  name="cil-basket"
                  class="text-success col-1"
                />
                <select
                  class="custom-select col-11"
                  v-model="shopObjectId"
                  disabled
                >
                  <option selected>{{ $t('selectshop') }}</option>
                  <option
                    v-for="shop in shops"
                    :key="shop.objectId"
                    :value="shop.objectId"
                  >
                    {{ shop.shopName }} - {{ shop.branchName }}
                  </option>
                </select>
              </div>
            </CCol>
            <CCol sm="3" md="2" col="3">
              <router-link :to="{ name: 'PaymentReport' }" replace>
                <CButton id="custompayBackButton" block color="light">
                  <CIcon name="cil-arrow-thick-from-right" />{{ $t('back') }}
                </CButton>
              </router-link>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol md="12" lg="12">
      <CCard class="shadow-sm">
        <CCardBody>
          <div class="row">
            <h2 id="custompayTitle" class="col-md-10 col-sm-9  col-9">
              {{ $t('report.txtCustomReport') }}
            </h2>
            <div
              v-if="isExport"
              class="col-md-2 col-sm-3 col-3 text-right text-success"
            >
              <CButton id="custompayExportButton" v-on:click="exportPaymentReport()" block color="info">
                <img src="/img/file-excel.png" alt="Excel Icon" style="width: 16px; height: 16px; margin-right: 8px; vertical-align: middle; position: relative; top: -2px;" />{{ $t('export') }}
              </CButton>
            </div>
          </div>
          <CRow>
            <CCol sm="12" lg="12">
              <show-date></show-date>
              <hr />
              <CRow v-if="data.length != 0">
                <CCol class="col-md-6">
                  <CCard class="d-flex align-items-center">
                    <CCardBody>
                      <CChartDoughnut
                        id="custompayDoughnutChart"
                        style="height: 250px"
                        :datasets="paymentChart.datasets"
                        :labels="paymentChart.labels"
                        :options="doughnutOptions"
                      />
                    </CCardBody>
                  </CCard>
                </CCol>
                <CCol class="col-md-6">
                  <CCardBody>
                    <CRow>
                      <CCardBody
                        style="margin: 0px; padding: 0px;"
                        lg="6"
                        sm="6"
                        col="6"
                        v-for="(item, index) in summaryCustomPay"
                        :key="index"
                      >
                        <CCallout color="success">
                          <h5 id="custompayName" class="text-success">
                            {{ item.customPaymentName }}
                          </h5>
                          <CRow>
                            <CCol >
                              <strong class="h6 text-muted">
                                {{ $t('paymentAmount') }}
                              </strong>
                            </CCol>
                            <CCol class="text-right ">
                              <strong id="custompayAmount" class="h6 text-muted">
                                {{ item.amount }}
                              </strong>
                            </CCol>
                          </CRow>
                        </CCallout>
                      </CCardBody>
                    </CRow>
                  </CCardBody>
                </CCol>
              </CRow>
              <DataTable
                id="custompayDatatable"
                style="white-space: nowrap;"
                :items="items"
                :fields="fields"
                :loading="loading"
                hover
                border
              >
              </DataTable>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  </div>
  <div v-else>
    <access-data></access-data>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CChartDoughnut } from '@coreui/vue-chartjs'
import moment from 'moment'
import axios from '@/services/service'
import report from '@/services/report'
import util from '@/util/util'
import permis from '@/util/permission'
import DataTable from '@/containers/DataTable'

export default {
  components: {
    CChartDoughnut,
    DataTable,
  },
  data() {
    return {
      data: [],
      details: [],
      customPayDetail: [],
      summary: {},
      loadingButton: true,
    }
  },
  computed: {
    ...mapGetters(['shops', 'date', 'users']),
    isPermission() {
      return permis.findPermissionRead('report', '/report/payment')
    },
    isExport() {
      return permis.findPermissionExport('report', '/report/payment')
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId
      },
      set(newValue) {
        return this.$store.dispatch('setShop', newValue)
      },
    },
    startDate() {
      return moment(String(this.date.start)).format('DD MMMM YYYY')
    },
    endDate() {
      return moment(String(this.date.end)).format('DD MMMM YYYY')
    },
    paymentChart() {
      let customPay = this.customPayDetail
      const data = []
      const labels = []
      for (let i = 0; i < customPay.length; i++) {
        labels.push(customPay[i].customPaymentName)
        data.push(customPay[i].amount)
      }
      return {
        labels: labels,
        datasets: [
          {
            backgroundColor: [
              '#5CBA96',
              '#F29089',
              '#4CB2D4',
              '#F6CE3B',
              '#A9A7D6',
              '#BA5C80',
              '#9992D1',
            ],
            data: data,
            borderWidth: 1,
          },
        ],
      }
    },
    doughnutOptions() {
      return {
        legend: {
          position: 'bottom',
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    },
    fields() {
      return [
        {
          key: 'id',
          label: this.$i18n.t('#'),
          _classes: 'text-center text-dark font-weight-normal',
          _style: 'width:5%',
        },
        {
          key: 'customPaymentName',
          label: this.$i18n.t('customPaymentName'),
          _classes: 'text-left text-dark font-weight-normal',
        },
        {
          key: 'amount',
          label: this.$i18n.t('paymentAmount'),
          _classes: 'text-right text-dark font-weight-normal',
        },
      ]
    },
    summaryCustomPay() {
      let data = this.customPayDetail
      let detail = []
      for (let i = 0; i < data.length; i++) {
        detail.push({
          customPaymentName: data[i].customPaymentName,
          amount: util.convertCurrency(data[i].amount),
        })
      }
      return detail
    },
    items() {
      let items = this.customPayDetail || []
      let objects = []
      for (let i = 0; i < items.length; i++) {
          let item = items[i]
          objects.push({
            id: i + 1,
            customPaymentName: item.customPaymentName || '-',
            amount: util.convertCurrency(item.amount || 0),
          })
      }
      return  objects
    },
  },
  created() {
    this.getPaymentReport()
  },
  methods: {
    ...util,
    getPaymentReport() {
      this.loadingButton = false
      const uid = `${localStorage.getItem('shopsUid')}`
      const shopObjectId = this.shopObjectId

      const startAt = moment(String(this.date.start)).format('YYYY-MM-DD')
      const endAt = moment(String(this.date.end)).format('YYYY-MM-DD')

      const params = {
        shopObjectId: shopObjectId,
        startAt: startAt,
        endAt: endAt,
      }

      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }

      this.loading = true
      axios({
        url: '/payment/v1.0/getreport/' + uid + '/data',
        params: params,
        headers: headers,
        method: 'GET',
      })
        .then((res) => {
          this.data = res.data.data.dates
          this.summary = res.data.data.summary
          this.customPayDetail = res.data.data.summary.customPayDetail
          this.loading = false
          this.loadingButton = true
        })
        .catch((error) => {
          console.log(error)
        })
    },
    exportPaymentReport() {
      const uid = `${localStorage.getItem('shopsUid')}`
      const shopObjectId = this.shopObjectId

      const startAt = moment(String(this.date.start)).format('YYYY-MM-DD')
      const endAt = moment(String(this.date.end)).format('YYYY-MM-DD')

      const params = {
        shopObjectId: shopObjectId,
        startAt: startAt,
        endAt: endAt,
      }

      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }

      report({
        url: '/payment/v1.0/getreport/' + uid + '/excel',
        params: params,
        method: 'GET',
        headers: headers,
        responseType: 'blob', // important
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'รายงานการชำระเงิน.xlsx') //or any other extension
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    toggleDetails(item) {
      const position = this.details.indexOf(item)
      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(item)
    },
  },
}
</script>
